class FeaturedProductsTech extends HTMLElement {
    constructor() {
        super();
        this.init();
    }

    init() {
        this.initSizeOpeners();
        this.initVariantSelectors();
        this.initProductForms();
        this.initCartResetListener();
    }

    initSizeOpeners() {
        const sizesOpeners = this.querySelectorAll('.sizes-opener');
        sizesOpeners.forEach((opener) => {
            opener.addEventListener('click', () => {
                const sizeSelector = opener.nextElementSibling;
                if (sizeSelector.style.display === 'none' || sizeSelector.style.display === '') {
                    sizeSelector.style.display = 'block';
                    opener.textContent = 'HIDE OPTIONS';
                } else {
                    sizeSelector.style.display = 'none';
                    opener.textContent = 'SELECT OPTIONS';
                }
            });
        });
    }

    initVariantSelectors() {
        const variantSelectors = this.querySelectorAll('.variant-selector');
        variantSelectors.forEach((select) => {
            select.addEventListener('change', () => {
                const selectedOption = select.options[select.selectedIndex];
                const isAvailable = selectedOption.getAttribute('data-available') === 'true';
                const price = selectedOption.getAttribute('data-price');
                const comparePrice = selectedOption.getAttribute('data-compare-price');

                const priceDisplay = select.closest('.featured-product-item').querySelector('.price-display');
                if (priceDisplay) {
                    priceDisplay.textContent = price;
                }

                const addToCartBtn = select.closest('.size-selector').querySelector('.btn--add-to-cart');
                const btnText = addToCartBtn.querySelector('.btn-text');

                if (isAvailable) {
                    addToCartBtn.disabled = false;
                    btnText.textContent = 'ADD TO CART';
                    addToCartBtn.classList.remove('btn-disabled');
                } else {
                    addToCartBtn.disabled = true;
                    btnText.textContent = 'SOLD OUT';
                    addToCartBtn.classList.add('btn-disabled');
                }
            });

            select.dispatchEvent(new Event('change'));
        });
    }

    initProductForms() {
        const productForms = this.querySelectorAll('.product-form');
        productForms.forEach((form) => {
            form.addEventListener('submit', (e) => {
                const button = form.querySelector('.btn--add-to-cart');
                if (button) {
                    form.classList.add('loading');
                    button.disabled = true;
                }
            });
        });

        const addToCartButtons = this.querySelectorAll('button.btn.btn--add-to-cart');
        addToCartButtons.forEach((button) => {
            button.addEventListener('click', () => {
                setTimeout(() => {
                    const cartBubble = document.querySelector('a#header-cart-bubble');
                    if (cartBubble) {
                        cartBubble.click();
                    }
                }, 2000);
            });
        });
    }

    initCartResetListener() {
        document.addEventListener('liquid-ajax-cart:request-end', (event) => {
            const allForms = this.querySelectorAll('.product-form');
            allForms.forEach((form) => {
                form.classList.remove('loading');
                const button = form.querySelector('.btn--add-to-cart');
                if (button) {
                    button.disabled = false;
                }
            });

            if (
                event.detail &&
                event.detail.requestState &&
                event.detail.requestState.responseData &&
                !event.detail.requestState.responseData.errors
            ) {
                const allSizeSelectors = this.querySelectorAll('.size-selector');
                const allSizesOpeners = this.querySelectorAll('.sizes-opener');

                allSizeSelectors.forEach((selector) => {
                    selector.style.display = 'none';
                });

                allSizesOpeners.forEach((opener) => {
                    opener.textContent = 'SELECT OPTIONS';
                });
            }
        });
    }
}
customElements.define('featured-products-tech', FeaturedProductsTech);